export { default as InvestmentCard } from './InvestmentCard';
